import { 
  CheckSquare, 
  FileText, 
  Calculator, 
  BookOpen, 
  Target, 
  Download, 
  Shield,
  Lock,
  FileCheck,
  AlertTriangle,
  ClipboardCheck,
  Database,
  Key,
  FileSearch,
  Mail,
  Network
} from "lucide-react";

export const iconMap: Record<string, any> = {
  'CheckSquare': CheckSquare,
  'FileText': FileText,
  'Calculator': Calculator,
  'BookOpen': BookOpen,
  'Target': Target,
  'Download': Download,
  'Shield': Shield,
  'Lock': Lock,
  'FileCheck': FileCheck,
  'AlertTriangle': AlertTriangle,
  'ClipboardCheck': ClipboardCheck,
  'Database': Database,
  'Key': Key,
  'FileSearch': FileSearch,
  'Mail': Mail,
  'Network': Network,
};

export const availableIcons = Object.keys(iconMap);

export const getIconComponent = (iconName: string) => {
  return iconMap[iconName] || FileText; // Default to FileText if icon not found
};
